import {
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
  } from "@chakra-ui/react";
  import React, {  useState } from "react";
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
  import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import moment from "moment";
import { pmtNumberFormate } from "jsFunctions/helperFunctions";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
  

  const DataRow = ({ label, value, type,currency }) => {
    return (
      <>
          <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const getPaymentMode=(id)=>{
    const payMod = allPaymentMode.find(opt=> opt.id === id);
    return payMod?.value || ""

  }
  const InvoicePaymentRecordModel = ({ openInfoModal, closeInfoModal, selectedItem, role }) => {
    const [activeTab, setActiveTab] = useState("information");
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent  
          top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>Payment Information</span>
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5">Invoice Details</h5>
  
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Number"
                            value={InvoiceNumberFormate(selectedItem?.inId?.inNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Invoice Date" value={
                              selectedItem?.inId?.inDt
                                ? moment(selectedItem?.inId?.inDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            } />
                        </Col>
                      </Row>
                        <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Currency"
                            value={(selectedItem?.inId?.inCr)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Due Date" value={
                              selectedItem?.inId?.duDt
                                ? moment(selectedItem?.inId?.duDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            } />
                        </Col>
                        </Row>
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">Client Detail</h5>
                    
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Client Name"
                            value={selectedItem?.cId?.clName}
                          />
                        </Col>
                        <Col>
                       
                        </Col>
                       
                      </Row>
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">Payment Detail</h5>
                      <Row className="info-row">
                     <Col>
                     <DataRow
                            label="Payment ID"
                            value={pmtNumberFormate(selectedItem?.pyNo || 0)}
                          />
                        </Col>
                        <Col>
                        <DataRow label="Payment Date" value={
                              selectedItem?.dt
                                ? moment(selectedItem?.dt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            } />
                        </Col>
                     </Row>
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Amount"
                            value={selectedItem?.amt || 0}
                            type="Amount"
                            currency={selectedItem?.inId?.inCr || "INR"}

                          />
                        </Col>
                      <Col>
                          <DataRow
                            label="Bank Charges"
                            value={selectedItem?.crg || 0}
                            type='Amount'
                            currency={selectedItem?.inId?.inCr || "INR"}
                          />
                        </Col>
                    </Row>
                    <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Refrence No"
                            value={selectedItem?.ref || "-"}
                          />
                        </Col>
                      <Col>
                          <DataRow
                            label="Payment Mode"
                            value={getPaymentMode(selectedItem?.mod || 0)}
                          />
                        </Col>
                    </Row>
                    </div>
                  </Tab>
                 <Tab
                  eventKey=""
                  title=""
                  disabled
                  className="main-tab-item"
                 >
                 </Tab>
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default InvoicePaymentRecordModel;
  